<template>
  <div v-if="alerts.length" class="global-alerts">
    <div 
      v-for="(alert, index) in alerts" 
      :key="index"
      class="alert"
      :class="`alert-${alert.type}`"
    >
      {{ alert.message }}
      <button @click="removeAlert(index)">&times;</button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    alerts() {
      return this.$store.state.globalStore.alerts
    }
  },
  methods: {
    removeAlert(index) {
      this.$store.commit('removeAlert', index)
    }
  }
}
</script>

<style scoped>
.global-alerts {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.alert {
  padding: 15px 20px;
  margin-bottom: 10px;
  border-radius: 4px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 300px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.alert-success {
  background-color: #4CAF50;
}

.alert-error {
  background-color: #F44336;
}

.alert-warning {
  background-color: #FF9800;
}

.alert-info {
  background-color: #2196F3;
}

.alert button {
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-left: 15px;
}
</style>